export const ActionTypes = {
    UPDATE_PRIORITIZED_TO_FOCUSED: "UPDATE_PRIORITIZED_TO_FOCUSED_REQUEST",
    UPDATE_PRIORITIZED_TO_FOCUSED_SUCCESS: "UPDATE_PRIORITIZED_TO_FOCUSED_SUCCESS",
    UPDATE_PRIORITIZED_TO_FOCUSED_FAILURE: "UPDATE_PRIORITIZED_TO_FOCUSED_FAILURE",
}
